/**
 * Created by andrey on 14.08.2025
 */

const Map2dLayerView = cc.Node.extend({
    ctor: function (map2d) {
        this._super();

        this.map2d = map2d;
        this.map2dView = map2d.onDiscoverMapView();

        this.pool = new Map2dCellPool(map2d, this);

        this.cells = [];

        this.scheduleUpdateWithPriority(-1);
    },

    update: function (dt) {
        this._super(dt);

        this.pool.update();
    },

    updateChildrenOrder: function () {
        let cellView, changed = false;
        const children = this.children || [];
        const map2d = this.map2d;

        const bgSize = cleverapps.resolution.getBgSize();
        const sceneBox = cc.rect(0, 0, bgSize.width, bgSize.height);

        const isVisibleCellView = (cellView) => {
            const x = cellView.cell.x;
            const y = cellView.cell.y;

            if (cellView.children.length === 0 || map2d.isScreenCellPosition(x, y)) {
                return true;
            }

            for (let j = 0; j < cellView.children.length; j++) {
                const tile = cellView.children[j];
                if (cc.rectIntersectsRect(sceneBox, tile.getBoundingBoxToWorld())) {
                    return true;
                }
            }

            return false;
        };

        for (const y in this.cells) {
            for (const x in this.cells[y]) {
                if (!map2d.isVisibleCell(+x, +y)) {
                    this.putCellToPool(+x, +y);
                    changed = true;
                }
            }
        }

        let size = 0;

        this.map2d.iterateVisibleIsoCells((x, y) => {
            cellView = this.cells[y] && this.cells[y][x];
            if (cellView) {
                if (children[size] !== cellView) {
                    children[size] = cellView;
                    changed = true;
                }

                if (cellView.pixiObject) {
                    cellView.pixiObject.setSiblingIndex(size);
                }

                cellView.setVisible(isVisibleCellView(cellView));

                size++;
            }
        });

        changed = changed || children.length !== size;

        if (changed) {
            children.length = size;

            if (engine === "cocos2d") {
                cc.renderer.setChildrenOrderDirty();
            }
        }
    },

    addChild: function (child, localZOrder, tag) {
        if (!child.cellView) {
            throw new Error("Map2dLayerView.addChild: child is not a cell view");
        }

        this._super(child, localZOrder, tag);
    },

    addTile: function (layer, x, y, tile) {
        if (!this.cells[y]) {
            this.cells[y] = {};
        }

        this.map2d.showTile(x, y);

        let cellView = this.cells[y][x];
        if (!cellView) {
            cellView = this.cells[y][x] = this.pool.getFromPool(x, y);
        }
        if (!cellView.isVisible()) {
            cellView.setVisible(true);
        }

        this.map2d.setChildrenOrderDirty();

        if (tile.parent) {
            const position = this.convertToNodeSpace(tile.parent.convertToWorldSpace(tile.getPosition()));
            tile.removeTemporarily(false);
            tile.setAlignment(Math.round(position.x), Math.round(position.y));
        } else {
            this.map2dView.alignViewInGrid(x, y, tile);
        }

        cellView.addChild(tile);

        tile.setOrderOfArrival(cc.s_globalOrderOfArrival++);
        tile.cell = { layer, x, y };

        tile.saveStack = true;

        if (tile.additionalViews) {
            Object.values(tile.additionalViews).forEach((view) => {
                this.map2dView.upAdditionalViewAboveClouds(tile, view);
            });
        }

        if (tile.unit && tile.unit.onShowTile) {
            tile.unit.onShowTile();
        }
    },

    getCellLayerTile: function (layer, x, y) {
        const object = this.map2d.getValue(layer, x, y);
        if (object === undefined) {
            return;
        }

        if (layer === Map2d.LAYER_UNITS) {
            return object instanceof Unit && object.onGetView() ? object.onGetView() : undefined;
        }
        if (layer === Map2d.LAYER_FOG) {
            return object instanceof FogTile && object.onGetView() ? object.onGetView() : undefined;
        }

        if (object instanceof BorderTile) {
            return object.onGetView ? object.onGetView() : undefined;
        }

        const cellView = this.cells[y] && this.cells[y][x];
        if (cellView) {
            for (let i = 0, child; i < cellView.children.length; i++) {
                child = cellView.children[i];
                if (child.cell && child.cell.view && child.cell.layer === layer) {
                    return child;
                }
            }
        }
    },

    showLayerTile: function (layer, x, y) {
        if (!this.cells[y]) {
            this.cells[y] = {};
        }

        let cellView = this.cells[y][x];
        if (!cellView && this.pool.has(x, y)) {
            cellView = this.cells[y][x] = this.pool.getFromPool(x, y);
        }
        if (cellView && !cellView.isVisible()) {
            cellView.setVisible(true);
            this.map2d.setChildrenOrderDirty();
        }

        const object = this.map2d.getValue(layer, x, y);

        if (object === undefined) {
            return;
        }

        if (!cellView) {
            this.cells[y][x] = this.pool.getFromPool(x, y);
            this.map2d.setChildrenOrderDirty();
        }

        let tile = this.getCellLayerTile(layer, x, y);
        if (tile) {
            return;
        }

        const X = this.map2d.pointer.x;
        const Y = this.map2d.pointer.y;

        this.map2d.setPointer(x, y);

        cleverapps.toArray(object).forEach((item) => {
            tile = this.map2dView.createView(item);

            if (tile) {
                this.map2dView.addTile(tile.layer || layer, x, y, tile);
                tile.cell.view = true;
            }
        });

        this.map2d.setPointer(X, Y);
    },

    removeTiles: function (cells) {
        cells.forEach((cell) => {
            this.putCellToPool(cell.x, cell.y);
        });

        this.pool.cleanUp(true);
    },

    cleanupCellViews: function (cellViews) {
        this.removeChildren(cellViews, true);

        for (let i = 0; i < cellViews.length; i++) {
            const cellView = cellViews[i];
            for (let j = cellView.children.length - 1; j >= 0; j--) {
                cellView.children[j].parent = null;
                this.putTileInPool(cellView.children[j]);
            }
        }
    },

    putCellToPool: function (x, y) {
        const cellView = this.cells[y] && this.cells[y][x];
        if (!cellView) {
            return;
        }

        delete this.cells[y][x];
        this.pool.add(x, y, cellView);
        this.map2d.setChildrenOrderDirty();
    },

    putTileInPool: function (tile) {
        if (tile.clearAnimations) {
            tile.clearAnimations();
        }

        const createErrorLog = function (message, tile, notSaveToRemoveAnimation) {
            message = `${message} Cell: ${JSON.stringify(tile.cell)} `;
            if (tile.unit) {
                message += ` Unit: ${Unit.GetKey(tile.unit)} `;
            }

            if (notSaveToRemoveAnimation) {
                message += ` Not save to remove animation: ${notSaveToRemoveAnimation} `;
                message += (tile.sprite.actionStack || "");
            } else {
                message += (tile.actionStack || "");
            }

            if (cleverapps.config.debugMode) {
                throw message;
            } else {
                cleverapps.throwAsync(message);
            }
        };
        if (tile.getNumberOfRunningActions() > 0) {
            createErrorLog("Node with action is removed.", tile);
        }
        if (tile.sprite instanceof cleverapps.Spine && !tile.sprite.isSaveToRemove()) {
            createErrorLog("Node with spine is removed.", tile, tile.sprite.getCurrentAnimationName(0));
        }

        if (cleverapps.oneOf(tile, Map2dWaterView, Map2dGroundView, Map2dChessGroundView, Map2dBorderView)) {
            cleverapps.pool.putInPool(tile);
        } else {
            tile.removeFromParent();
        }

        if (cleverapps.config.debugMode) {
            tile.cleanupBorder();
        }

        delete tile.cell;
    },

    listTiles: function (layer, x, y) {
        const cellView = this.cells[y] && this.cells[y][x];
        const tiles = cellView && cellView.children || [];
        return tiles.filter((tile) => tile.cell && tile.cell.view && tile.cell.layer === layer);
    },

    removeChild: function (child, cleanup = true) {
        this._detachChild(child, cleanup);

        if (child.isVisible() && this.isDisplayed()) {
            cc.renderer.setChildrenOrderDirty();
        }
    },

    sortAllChildren: function () {
        if (!this._reorderChildDirty) {
            this._reorderChildDirty = false;
        }
    },

    cleanup: function () {
        // children might not be updated if visible cells changed but updateChildrenOrder wasn't called yet
        this.updateChildrenOrder();

        this.pool.cleanUp(true);

        cc.Node.prototype.cleanup.call(this);
    }
});
